<div style="width: 100%; position: relative">
  <rask-map [settings]="mapsettings" [filter]="filter">
    <rask-map-draw [enabled]="true"></rask-map-draw>
    <rask-map-layers></rask-map-layers>
  </rask-map>

  <div class="popup popupmottagningsplats" #infowindow>
  </div>

  <div class="popup popupfeatures" #importwindow>
    <ul>
      @for (feature of featureLayers; track feature) {
        <li>
          {{ feature.layerid }}
          @for (geometry of feature.geometries; track geometry) {
            <div>
              <rask-toggle-panel size="4" [label]="getFeatureName(feature.layerid, geometry)"
                [defaultExpanded]="">
                <ng-container header></ng-container>
                <ng-container>
                  <rask-button class="list-menu" (click)="clickFeatureImport(geometry)" color="tertiary">
                    IMPORT
                  </rask-button>
                  <rask-button class="list-menu" (click)="clickFeatureInfo($event, geometry)"
                    color="tertiary">
                    ATTRIBUT&nbsp;<i class="fal fa-angle-double-right"></i>
                  </rask-button>
                </ng-container>
              </rask-toggle-panel>
            </div>
          }
        </li>
      }
    </ul>
  </div>

  <div class="popup popupattributes" #attributeswindow>
    @if (featuregeometry) {
      <div style="margin-bottom: 20px">
        <table class="attributestable" style="width: 100%">
          @for (attribute of getAttributes(featuregeometry); track attribute) {
            <tr>
              <td>{{ attribute.key }}</td>
              <td>{{ attribute.value }}</td>
            </tr>
          }
        </table>
      </div>
    }
  </div>
</div>